import {
  CallStateAdminLockReason,
  CallStateLockInitiator,
  CallStateStudentLockReason,
  CallStateSystemLockReason,
} from '@engoo/realtime-protocol/callState';
import { Record } from 'immutable';

// The order of the lock status is important as previous state should not be reachable.
export enum LockStatus {
  Init,
  Unlocked,
  Locked,
}

const LockStatusName: {
  [I in LockStatus]: string;
} = {
  [LockStatus.Init]: 'init',
  [LockStatus.Unlocked]: 'unlocked',
  [LockStatus.Locked]: 'locked',
};

export const getLockStatusName = (lockEvent: LockStatus): string => {
  return LockStatusName[lockEvent];
};

export type LockReason = CallStateAdminLockReason | CallStateStudentLockReason | CallStateSystemLockReason;

interface ILockStateLocked {
  lockInitiator: CallStateLockInitiator;
  lockReason: LockReason;
  lockStatus: LockStatus.Locked;
  lockTime: Date;
}

export class LockStateLocked extends Record<ILockStateLocked>({
  lockInitiator: CallStateLockInitiator.System,
  lockReason: CallStateSystemLockReason.EndLesson,
  lockStatus: LockStatus.Locked,
  lockTime: new Date(),
}) {
  public constructor(args: ILockStateLocked) {
    super(args);
  }
}

interface ILockStateOther {
  lockInitiator?: undefined;
  lockReason?: undefined;
  lockStatus: LockStatus.Init | LockStatus.Unlocked;
  lockTime?: Date;
}

export class LockStateOther extends Record<ILockStateOther>({
  lockInitiator: undefined,
  lockReason: undefined,
  lockStatus: LockStatus.Init,
  lockTime: undefined,
}) {
  public constructor(args: ILockStateOther) {
    super(args);
  }
}

/**
 * @param lockStatus - Describes the latest status of the lock events.
 * @param lockTime - This reflects the actual end time or expected end time of a lesson.
 */
export type LockState = LockStateLocked | LockStateOther;
